// extracted by mini-css-extract-plugin
export default {"accordion":"style_accordion__VBOqX","summary":"style_summary__36SVV","content":"style_content__Us1k1"};